import { MeteoMetricCell } from './MeteoMetricCell.component';
import { MeteoRowTitle } from './MeteoRowTitle.component';
import { ForecastData, ForecastParamCode, ForecastWindDirection } from 'pleinchamp-api-client';
import { useSelector } from 'react-redux';
import { PlcTextListLoader } from '@components/Loaders/PlcTextLoader.component';
import { Breakpoint } from '@styles/breakpoints';
import { userSelectors } from '@user/business/User.store';
import classnames from 'classnames';
import style from '../MeteoWeatherTableContent.module.scss';

interface Props {
  metric: ForecastData<string | number | ForecastWindDirection>[];
  metricCode: ForecastParamCode;
  isLoading?: boolean;
  is15Days?: boolean;
  is36h?: boolean;
  hoveredIndex?: number;
  onMouseEnter: (index: number) => void;
}

function MeteoMetricRow({ metric, isLoading, is15Days, is36h, metricCode, hoveredIndex, onMouseEnter }: Props) {
  const isPro = useSelector(userSelectors.isPro);
  if (!metric) {
    return null;
  }

  const isDecimal =
    metricCode === ForecastParamCode.precipitationAmount ||
    metricCode === ForecastParamCode.precipitationProbability ||
    metricCode === ForecastParamCode.volumetricSoilWaterMeanAt5cm ||
    metricCode === ForecastParamCode.volumetricSoilWaterMeanAt50cm ||
    metricCode === ForecastParamCode.evapotranspiration;

  const isMoonPhase = metricCode === ForecastParamCode.moonPhase;

  return (
    <tr key={metricCode}>
      <th
        style={{
          left: is36h && window.innerWidth >= Breakpoint.m ? '0' : '',
        }}
      >
        {isLoading ? (
          <PlcTextListLoader
            fixedWidth
            textProps={[{ variant: 'h5', width: 140 }]}
            uniqueKey={`meteoMetricRow-${metricCode}`}
          />
        ) : (
          <MeteoRowTitle forecastParam={metricCode} is15Days={is15Days} is36h={is36h} isPro={isPro} />
        )}
      </th>
      <td className={classnames(style.fifteenDays, style.left)} />

      {metric.map((d, i) => (
        <MeteoMetricCell
          key={metricCode + i.toString()}
          data={d.value}
          emphasis={i === hoveredIndex}
          isDecimal={isDecimal}
          isLoading={isLoading}
          isMoonPhase={isMoonPhase}
          onMouseEnter={() => onMouseEnter(i)}
        />
      ))}
      <td className={classnames(style.fifteenDays, style.right)} />
    </tr>
  );
}

export { MeteoMetricRow };
